<template>
  <div class="validation_request_order_offer_price" v-if="ready">
    <div class="validation_request_order_offer_price_default">
      <div>
        <span class="price_value" v-if="default_price.base_price > 0"> Prix: {{ (default_price.base_price / 100).toFixed(2)}} {{default_price.currency}} / {{ default_price.unit_text}}</span>
        <span class="price_value"v-else>Inclus</span>
        <span class="price_quantity"> Quantité: {{ default_price.base_quantity }} </span>
      </div>
    </div>
    <div class="validation_request_order_offer_price_default_list" v-if="default_price_list.length > 1">
      <ul v-for="(price, idx) in default_price_list" :key="'price-list-' + idx">
        <li>
          <div>
            <span class="price_value"> Prix: {{ (price.base_price / 100).toFixed(2)}} {{price.currency}} / {{price.unit_text}}</span>
            <span class="price_quantity">Quantité: {{ price.quantity }} </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name:"ValidationRequestableOrderOfferPrice",
  props:["default_price", "default_price_list"],
  computed: {
    ready() {
      return this.default_price && this.default_price_list
    },


  },
}
</script>
<style scoped>
.validation_request_order_offer_price{

}

.price_value {
  
}

.price_quantity {

}

</style>

<!-- "default_price":{
   "base_price":90000,
   "currency":"EUR",
   "base_quantity":1,
   "unit":"MOS",
   "unit_text":"Mois"
},
"default_price_list":{
   "MOS":{
      "base_price":90000,
      "currency":"EUR",
      "base_quantity":1,
      "unit":"MOS",
      "unit_text":"Mois"
   }
}, -->



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/Offer/Price.vue